import { useState, useEffect } from "react";

const DEFAULT_PREFERENCES = {
  necessary: true,
  functional: false,
  analytics: false,
  marketing: false,
  tagManager: false,
};

export default function useConsent() {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    try {
      const savedConsent = JSON.parse(
        localStorage.getItem('cookiePreferences')
      );
      if (savedConsent) {
        // Asegurarse de que todas las categorías existan
        const validatedConsent = {
          ...DEFAULT_PREFERENCES,
          ...savedConsent,
        };
        setConsent(validatedConsent);
      }
    } catch (error) {
      console.error('Error al cargar las preferencias de cookies:', error);
      setConsent(DEFAULT_PREFERENCES);
    }
  }, []);

  const saveConsent = (preferences) => {
    // Asegurarse de que las cookies necesarias siempre estén activadas
    const validatedPreferences = {
      ...preferences,
      necessary: true,
    };
    setConsent(validatedPreferences);
    localStorage.setItem('cookiePreferences', JSON.stringify(validatedPreferences));
  };

  return [consent, saveConsent];
}